type FirebaseAuthError = {
  code: string;
  message: string;
};

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  'auth/invalid-credential': 'Email ou senha incorretos. Por favor, verifique suas credenciais e tente novamente.',
  'auth/user-not-found': 'Não existe uma conta com este email. Por favor, verifique o email ou crie uma nova conta.',
  'auth/wrong-password': 'Senha incorreta. Por favor, tente novamente.',
  'auth/email-already-in-use': 'Este email já está sendo usado por outra conta.',
  'auth/weak-password': 'A senha deve ter pelo menos 6 caracteres.',
  'auth/invalid-email': 'O email fornecido é inválido. Por favor, use um email válido.',
  'auth/user-disabled': 'Esta conta foi desativada. Entre em contato com o suporte.',
  'auth/too-many-requests': 'Muitas tentativas de login. Por favor, aguarde alguns minutos antes de tentar novamente.',
  'auth/operation-not-allowed': 'Este tipo de login não está habilitado. Entre em contato com o suporte.',
  'auth/network-request-failed': 'Erro de conexão. Verifique sua internet e tente novamente.',
  'auth/popup-closed-by-user': 'O processo de login foi interrompido. Por favor, tente novamente.',
  'auth/unauthorized-domain': 'Este domínio não está autorizado para realizar operações de login.',
  'auth/expired-action-code': 'O link de redefinição de senha expirou. Solicite um novo link.',
  'auth/invalid-action-code': 'O link de redefinição de senha é inválido. Solicite um novo link.',
};

export function translateAuthError(error: FirebaseAuthError): string {
  const errorCode = error.code.toLowerCase();
  return AUTH_ERROR_MESSAGES[errorCode] || 'Ocorreu um erro durante a autenticação. Por favor, tente novamente.';
}